var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9897 0.911133H0L2.78821 8.52893C3.07414 9.31012 3.81748 9.82961 4.64935 9.82961H19.9276C21.0526 9.82961 22.058 10.5321 22.4448 11.5885C22.8317 12.645 23.837 13.3475 24.9621 13.3475H29.6787C31.3447 13.3475 32.8328 14.3892 33.4031 15.9545L33.8173 17.0918C34.3825 18.643 33.2337 20.284 31.5827 20.284H28.4181C26.763 20.284 25.2821 19.2556 24.704 17.7046L24.5954 17.4133C24.0173 15.8623 22.5364 14.8339 20.8812 14.8339H7.35036C6.25263 14.8339 5.48705 15.9225 5.85825 16.9555L14.22 40.2268H23.4358L17.9184 24.1785C17.83 23.9212 18.0212 23.6533 18.2933 23.6533H25.0105C26.1746 23.6533 27.2119 24.3882 27.5977 25.4865C28.3695 27.6831 30.444 29.153 32.7722 29.153H35.5318C41.154 29.153 45.0786 23.5824 43.1862 18.2883L41.1897 12.7028C39.7241 8.60253 35.8396 5.86584 31.4852 5.86584H22.0394C21.0341 5.86584 20.1368 5.23522 19.7963 4.28934C19.0666 2.26247 17.1439 0.911133 14.9897 0.911133Z",
    fill: "#0EFFD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7906 4.26933L19.7441 4.14685C19.7601 4.18739 19.7756 4.22822 19.7906 4.26933Z",
    fill: "url(#paint0_linear_298_1414)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8323 4.37925L22.833 12.2938C23.3312 12.946 24.1132 13.3473 24.9636 13.3473H29.6802C31.3461 13.3473 32.8343 14.389 33.4045 15.9544L33.8188 17.0916C34.3839 18.6429 33.2352 20.2839 31.5842 20.2839H28.4196C27.1654 20.2839 26.0112 19.6934 25.2741 18.7324L28.4008 26.9792C29.4187 28.3232 31.0246 29.1529 32.7736 29.1529H35.5333C36.6079 29.1529 37.6204 28.9494 38.5421 28.5832L30.2676 5.86571H22.0409C21.0678 5.86571 20.196 5.2749 19.8323 4.37925Z",
    fill: "url(#paint1_linear_298_1414)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_1414",
    x1: 22.2439,
    y1: 10.8055,
    x2: 31.0458,
    y2: 8.30092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA88E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AEFD4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_1414",
    x1: 22.2439,
    y1: 10.8055,
    x2: 31.0458,
    y2: 8.30092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA88E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AEFD4",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/NewLogo.79e638957bc60fe2f68be67562674029.svg";
export { ForwardRef as ReactComponent };